import {
  earnings,
  EarningsFilterStatsRequest,
  EarningsFilterStatsResponse,
} from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_EARNINGS_FILTER_STATS = 'QUERY_KEY_EARNINGS_FILTER_STATS';

export const useEarningsFilterStats = (body: EarningsFilterStatsRequest) =>
  useQuery({
    queryKey: [QUERY_KEY_EARNINGS_FILTER_STATS, body],
    queryFn: ({ signal }) => {
      const { path, schema } = earnings.postEarningsFilterStats;
      return wretchRequest<EarningsFilterStatsResponse>(path, {
        method: 'post',
        body,
        schema,
        signal,
      });
    },
    staleTime: getTimeTillEndOfDayMs(),
  });
